import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import styles from './customer-reviews-section.module.css'
import {
  FaffFreeMotoring,
  HowCinchWorks,
} from '../../types/customer-reviews-page'

export interface ReviewData {
  reviewData: HowCinchWorks | FaffFreeMotoring
  containerClass: string
  contentClass: string
}
const ReviewSection = ({
  reviewData,
  containerClass,
  contentClass,
}: ReviewData) => {
  const title = reviewData.title
  const body = renderWithResolver(reviewData.text)

  return (
    <section className={containerClass}>
      <div className={contentClass}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.body}>{body}</div>
      </div>
      <img
        className={styles.image}
        src={reviewData.image.filename}
        alt={reviewData.image.alt || ''}
      />
    </section>
  )
}

export const CustomerReviewsSection = ({
  howCinchWorks,
  faffFreeMotoring,
}: {
  howCinchWorks: HowCinchWorks
  faffFreeMotoring: FaffFreeMotoring
}) => (
  <>
    <ReviewSection
      reviewData={howCinchWorks}
      containerClass={styles.howCinchWorksContainer}
      contentClass={styles.howCinchWorksContent}
    />
    <ReviewSection
      reviewData={faffFreeMotoring}
      containerClass={styles.faffFreeMotoringContainer}
      contentClass={styles.faffFreeMotoringContent}
    />
  </>
)
